import { render, staticRenderFns } from "./MessengerEdit.vue?vue&type=template&id=0e5fdefc&scoped=true&"
import script from "./MessengerEdit.vue?vue&type=script&lang=js&"
export * from "./MessengerEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessengerEdit.vue?vue&type=style&index=0&id=0e5fdefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5fdefc",
  null
  
)

export default component.exports